import { useState } from 'react';
import { useAuthContext } from './useAuthContext';
import axios from '../functions/axios';

export const useLogin = () => {
  const [error, setError] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const { dispatch } = useAuthContext();

  const login = async (email, password) => {
    setLoading(true);
    try {
      const response = await axios.post(`/login`, {
        email,
        password,
      }, {
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (response.status !== 200 || !response.data.apiToken) {
        setError(response.data);
        setLoading(false);
        throw new Error('Incorrect credentials');
      }
      localStorage.setItem('user', JSON.stringify(response.data));
      axios.defaults.headers.common['Authorization'] = response.data.apiToken;
      dispatch({ type: 'LOGIN', payload: response.data });
      setLoading(false);
    } catch (err) {
      console.error(err);
    }
  }

  return {
    login,
    error,
    isLoading,
  }
};